export default function setErrorRequiredProdAction(errorRequiredProd) {
    return {
        type: 'SET_ERROR_REQUIERED_PROD',
        payload: errorRequiredProd
    }
}